module.exports = __webpack_public_path__ + "img/linse_bagt.77795705.jpg";